import { useAuth } from './useAuth';

export const useOrgId = () => {
  const { user, loading, orgId, orgIdStatus } = useAuth();
  const isLoading = loading || (!!user && (orgIdStatus === 'idle' || orgIdStatus === 'loading'));

  return { orgId, isLoading, status: orgIdStatus };
};
